import { useMutation } from "@apollo/client";
import type {
  UpdateConversationInput,
  UpdateConversationPayload,
  ConversationPatch,
} from "@casey/db-types";
import { UPDATE_CONVERSATION } from "../gql";

interface UpdateConversationVariables {
  input: UpdateConversationInput;
}

interface UpdateConversationResponse {
  updateConversation: UpdateConversationPayload;
}

export function useUpdateConversation() {
  const [updateSessionMutation, { loading, error }] = useMutation<
    UpdateConversationResponse,
    UpdateConversationVariables
  >(UPDATE_CONVERSATION);

  const updateSession = async (
    conversationId: string,
    patch: ConversationPatch,
  ) => {
    try {
      const result = await updateSessionMutation({
        variables: {
          input: {
            id: conversationId,
            patch,
          },
        },
      });

      return result.data?.updateConversation?.conversation;
    } catch (err) {
      console.error("Error updating interview session:", err);
      throw err;
    }
  };

  const archiveSession = async (conversationId: string) => {
    return updateSession(conversationId, {
      archivedAt: new Date().toISOString(),
    });
  };

  const updateStatus = async (conversationId: string, status: string) => {
    return updateSession(conversationId, {
      status,
    });
  };

  return {
    updateSession,
    archiveSession,
    updateStatus,
    loading,
    error,
  };
}

export type { UpdateConversationVariables };
